import {Button, Col} from "antd";
import { useMediaQuery } from "react-responsive";

export const FollowedUser = ({userData, followedUser, texts, label}) => {
  const isMobile = useMediaQuery({maxWidth: 1024})

  return(
    <>
      <Col>
        <Button
           style={{
              background: "#bfbfbf",
              borderColor: "#bfbfbf",
              color: "#fff",
              padding: "12px 10px",
              fontSize: isMobile ? "12px": "16px",
              fontWeight: "bold",
              borderRadius: "999px",
              minWidth: "10px",
            }}
          onClick={() => console.log("")}
          disabled={true}
        >
          {label || texts?.LB0132}
        </Button>
      </Col>
    </>
  );
};
